import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ExportFormatsApiService } from 'src/app/services/api/export-formats.service';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'export-button',
  templateUrl: './export-button.component.html',
  styleUrls: ['./export-button.component.scss'],
})
export class ExportButtonComponent implements OnInit, OnDestroy {
  textDirection: string;
  private unsubscribe: Subject<void> = new Subject();

  readonly showConfirmationDialog = signal(false);

  constructor(
    private exportFormatsApiService: ExportFormatsApiService,
    private localeService: LocaleService
  ) {}

  ngOnInit() {
    this.textDirection = this.localeService.getTextDirection();
  }

  emitFormat(formatParam: string) {
    this.exportFormatsApiService.getExportFormat(formatParam).pipe(takeUntil(this.unsubscribe)).subscribe((result) => {
      if (result.status === 'dialog-required') {
        this.showConfirmationDialog.set(true);
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
